import type * as React from 'react';
import { KeypointShapeIcon } from '../../components/KeypointShapeIcon';
import { COLORS, JOINT_COLORS, JOINT_SHAPES } from '../../config/constants';
import { t } from '../../config/strings';

const JOINT_ITEMS = [
  [t.legend.shoulder, JOINT_SHAPES.shoulder, JOINT_COLORS.shoulder],
  [t.legend.elbow, JOINT_SHAPES.elbow, JOINT_COLORS.elbow],
  [t.legend.pelvis, JOINT_SHAPES.pelvis, JOINT_COLORS.pelvis],
] as const;

const LINE_ITEMS = [
  [t.legend.leftLine, COLORS.edgeLeft],
  [t.legend.rightLine, COLORS.edgeRight],
] as const;

export function KeypointLegend(): React.ReactElement {
  return (
    <div
      className="hidden items-center gap-3 text-xs text-muted-foreground xl:flex"
      data-testid="keypoint-legend"
      aria-label={t.legend.ariaLabel}
    >
      {JOINT_ITEMS.map(([label, shape, color]) => (
        <span key={label} className="inline-flex items-center gap-1.5">
          <KeypointShapeIcon shape={shape} color={color} size={11} />
          <span>{label}</span>
        </span>
      ))}
      <span className="h-4 w-px bg-border" aria-hidden />
      {LINE_ITEMS.map(([label, color]) => (
        <span key={label} className="inline-flex items-center gap-1.5">
          <span className="h-0.5 w-4 rounded" style={{ backgroundColor: color }} aria-hidden />
          <span>{label}</span>
        </span>
      ))}
    </div>
  );
}
